/** Known MMS branch type labels shown in the branch context picker. */
export const BRANCH_TYPE_LABELS = {
  ECOM: 'ECOM',
  POS: 'POS'
}

/** Display order when a branch has multiple types. */
export const BRANCH_TYPE_ORDER = Object.keys(BRANCH_TYPE_LABELS)

/**
 * Resolve branch type badges from an MMS type string.
 * Supports multiple types (e.g. ECOM and POS together).
 * @param {string | null | undefined} mmsType
 * @returns {string[]}
 */
export function getBranchTypes(mmsType) {
  if (!mmsType) return []

  const normalized = String(mmsType).toUpperCase()
  const detected = BRANCH_TYPE_ORDER.filter((type) => normalized.includes(type))

  if (detected.length) {
    return detected.map((type) => BRANCH_TYPE_LABELS[type])
  }

  const fallback = normalized.split('_')[0]
  return fallback ? [fallback] : []
}
